<div class="ui-table-actions">
  <button
    *ngFor="let action of visibleActions"
    class="ui-table-actions__btn"
    type="button"
    [disabled]="action.disabled"
    [title]="action.type"
    (click)="onAction(action.type, $event)">
    <mat-icon>{{ iconMap[action.type] || 'more_horiz' }}</mat-icon>
  </button>
</div>
